import React, { useState } from 'react';
import { SnackbarLayout } from '../components/shared/Snackbar';
import { AlertColor } from '@mui/material';

interface SnackbarObject {
    id: number;
    variant: AlertColor;
    jsx: React.ReactElement;
}

let snackbar, setSnackbar;
export const SnackbarContent: React.FC = () => {
    [snackbar, setSnackbar] = useState<SnackbarObject[]>([]);
    return snackbar.map((snack) => snack.jsx);
};

const addSnackbar = (snack: SnackbarObject) => {
    setSnackbar((prevState) => [snack, ...prevState]);
};

const deleteSnackbar = (id) => {
    setSnackbar((prevSnacks) => {
        return prevSnacks.filter((snack) => {
            return String(snack.id) !== String(id);
        });
    });
};

export default {
    success(msg: string) {
        this.snackbar(msg, 'success');
    },
    warning(msg: string) {
        this.snackbar(msg, 'warning');
    },
    info(msg: string) {
        this.snackbar(msg, 'info');
    },
    error(msg: string) {
        this.snackbar(msg, 'error');
    },
    snackbar(msg: string, variant) {
        let key = Math.random();
        const newSnackbar = {
            id: key,
            variant: variant,
            jsx: (
                <SnackbarLayout
                    onDismiss={deleteSnackbar}
                    id={key}
                    message={msg}
                    key={key}
                    variant={variant}
                />
            ),
        };
        addSnackbar(newSnackbar);
    },
};
